<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        Merci pour votre inscription et rendez-vous le mercredi 3 février 2021!
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
name: "ValidateInsc"
}
</script>

<style scoped>

</style>